<script>

import { options } from "../config";
import { GetContact } from "../Services/form0";
import { user } from "../store";
import {loading} from '../loader'


    let data = {
        data:{
            address:{}
        }
    }
    export let customer=null
    loading.set(true)
    const get = (c)=>{
        if(customer){
            const y = "customer/"+customer.split("customer/").join("")
            GetContact(options.profile,y,$user.idToken,
            (d=>{
                data = d;
                data.data.address = data.data.address||{}
                loading.set(false)
            }),(error)=>{
                console.error(error)
                loading.set(false)
            })
        }
    }

    $:get(customer)
</script>


{#if customer}
 
<div class="section_wrapper work_top">

    <div class="left">
        <!-- this div used for the top heading of the app page -->
        <div class="section_icon" style="background-image: url(images/section_icon_patientview.png);"></div>
        <div class="section_heading">
            <h1>{data.data.name}</h1>
            <table class="info_table">
                <tr>
                    <td>
                        Base2 Lead:<br/> {data.data.base2Lead}
                    </td>
                    <td>
                        Base2 Contact:<br/> {data.data.base2Contacts}
                    </td>
                    <td>
                        Customer Leads:<br/> {data.data.leads}
                    </td>
                    <td>
                        Customer Location:<br/> {data.data.address.country}
                    </td>
                </tr>
            </table> 
        </div>
    </div>

    <div class="right">
        <!-- this div uses "a" tags to create quicklinks -->
        <a href="#/customer/{customer}" class="linkbox green">Modify Customer</a>
        
    </div>

</div>
{/if}